/**
 * @param state {object} Global state
 * @returns {object} Domain state
 */
const getDomainState = state => {

    return state.notification;
};


/**
 * @param state {object} Global state
 * @returns {object[]} Toast messages
 */
export const getToastMessages = state => {

    return getDomainState(state)
        .toastMessages;
};
